import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["type", "disabled", "label"]
const _hoisted_2 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3"
}

import { EllipsisHorizontalIcon, LockClosedIcon, PencilIcon, UserPlusIcon, PrinterIcon } from '@heroicons/vue/20/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    label: {},
    icon: {},
    disabled: { type: Boolean },
    type: {},
    outline: { type: Boolean },
    fill: { type: Boolean },
    loading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['group', _ctx.outline ? 'is-outlined' : '', _ctx.fill ? 'is-filled' : '']),
    type: _ctx.type,
    disabled: _ctx.disabled,
    label: _ctx.label
  }, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (_ctx.icon === 'edit')
            ? (_openBlock(), _createBlock(_unref(PencilIcon), {
                key: 0,
                class: _normalizeClass(['icon', _ctx.outline ? 'is-outlined' : '']),
                "aria-hidden": "true"
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.icon === 'lock')
            ? (_openBlock(), _createBlock(_unref(LockClosedIcon), {
                key: 1,
                class: _normalizeClass(['icon', _ctx.outline ? 'is-outlined' : '']),
                "aria-hidden": "true"
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.icon === 'add-user')
            ? (_openBlock(), _createBlock(_unref(UserPlusIcon), {
                key: 2,
                class: _normalizeClass(['icon', _ctx.outline ? 'is-outlined' : '']),
                "aria-hidden": "true"
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.icon === 'print')
            ? (_openBlock(), _createBlock(_unref(PrinterIcon), {
                key: 3,
                class: _normalizeClass(['icon', _ctx.outline ? 'is-outlined' : '']),
                "aria-hidden": "true"
              }, null, 8, ["class"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_unref(EllipsisHorizontalIcon), {
          key: 1,
          class: _normalizeClass(['icon', _ctx.outline ? 'is-outlined' : '']),
          "aria-hidden": "true"
        }, null, 8, ["class"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ], 64))
  ], 10, _hoisted_1))
}
}

})